import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { SupplyVariantFragmentDoc } from './SupplyVariant.generated';
export type SupplyProductFragment = { id: string, pk: number, name: string, sortOrder: number, product: { id: string, pk: number, name: string, sku: string | null, images: Array<{ id: string, width: number, height: number, thumbnailUrl: string | null, url: string }> }, supplyVariants: Array<{ id: string, pk: number, name: string, variant: { id: string, pk: number, sku: string, wholesaleEnabled: boolean, wholesalePrice: { currency: string, undiscount: number, discount: number }, product: { id: string, specifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string }> } } }> };

export const SupplyProductFragmentDoc = gql`
    fragment SupplyProductFragment on SupplyProductType {
  id
  pk
  name
  sortOrder
  product {
    id
    pk
    name
    sku
    images {
      id
      width
      height
      url: image
      thumbnailUrl(method: CROP_WEBP, size: "40x40")
    }
  }
  supplyVariants {
    ...SupplyVariantFragment
    variant {
      id
      pk
      sku
      wholesaleEnabled
      wholesalePrice {
        currency
        undiscount
        discount
      }
      product {
        id
        specifics(filters: {siteSpecifics: true}) {
          id
          pk
          name
          shortName
          slug
        }
      }
    }
  }
}
    ${SupplyVariantFragmentDoc}`;